namespace GeniuzPOS.PosShift {
    export interface LookupRecieptforVatRefundRow {
        DocNo?: string;
        ShopId?: string;
        PropertyName?: string;
    }

    export namespace LookupRecieptforVatRefundRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.LookupRecieptforVatRefund';
        export const lookupKey = 'PosShift.LookupRecieptforVatRefund';

        export function getLookup(): Q.Lookup<LookupRecieptforVatRefundRow> {
            return Q.getLookup<LookupRecieptforVatRefundRow>('PosShift.LookupRecieptforVatRefund');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            DocNo = "DocNo",
            ShopId = "ShopId",
            PropertyName = "PropertyName"
        }
    }
}
